<template>
  <div>
    <!-- Progress Bar -->
    <div v-if="uploading">
      <p>Uploading: {{ progress }}%</p>
      <div class="progress-bar">
        <div class="progress" :style="{ width: progress + '%' }"></div>
      </div>
    </div>
    <!--End Progress Bar -->

    <!-- Success or Error Message -->
    <div v-if="message" :class="messageType">{{ message }}</div>
  </div>
</template>

<script>
export default {
  props: {
    uploading: Boolean,
    progress: Number,
    message: String,
    messageType: String
  },
  created() {
  }
};
</script>